import React, { useState } from "react";
import "./timetravel.scss";
import { Card, Col, Row } from "react-bootstrap";
import { Headings } from "../../atoms/Headings";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import { ModalOverlay } from "../../atoms/Modal";
import { addCommas } from "../../helpers/helpers";
import { actionCreators } from "../../redux/actions";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

const TimeTravel = (props) => {
  const {
    fetching: assumptionsFetch,
    data: assumptionsData,
    error: assumptionsError,
  } = useSelector(
    (state) => state.timeTravelAssumptions, // eslint-disable-line
  );

  const dispatch = useDispatch();

  // prettier-ignore
  const { getTimeTravelAssumptions } = bindActionCreators(
    actionCreators,
    dispatch
  );
  let investorObject = props?.investorObject;
  let totalFund = props?.totalFund;
  const { timeTravel } = props.timetravel;
  const [modalShow, setModalShow] = useState(false);
  const [showEstimatedVal, setShowEstimatedVal] = useState(true);

  const [isHovered, setIsHovered] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [blurCount, setBlurCount] = useState(0);

  const handleMouseEnter = () => {
    if (!isButtonClicked) {
      setIsHovered(true);
    }
  };
  const handleMouseLeave = () => {
    if (!isButtonClicked) {
      setIsHovered(false);
    }
  };
  const handleClickBys = () => {
    setIsButtonClicked(true);
    setIsHovered(false);
    setBlurCount(0);
    props.handleTellMeMore("BoostYourSavings");
  };
  const handleOnBlur = () => {
    if (blurCount == 1) {
      setIsButtonClicked(false);
    } else {
      setBlurCount(1);
    }
  };

  const [timeTravelAssumptionModal, setTimeTravelAssumptionModal] =
    useState(false);

  const handleAssumption = () => {
    setTimeTravelAssumptionModal(true);
    if (Object.keys(assumptionsData).length === 0) {
      getTimeTravelAssumptions(investorObject?.investorId);
    }
  };
  const handleEdit = () => {
    props.setCounter();
    setModalShow(true);
    setShowEstimatedVal(true);
  };
  const estimatedVal = addCommas(Math.trunc(props?.estimatedVal));
  const generateSpaces = (count) => {
    let spaces = "";
    for (let i = 0; i < count; i++) {
      spaces += "\u00A0"; // Unicode for non-breaking space
    }
    return spaces;
  };
  return (
    <>
      <Card className="time-travel-card mb-4 mb-md-0">
        <Card.Body>
          <Card.Text className="custom-bottom-text">
            <div className="maindiv">
              <Headings
                title="Time travel"
                iconName="edit"
                handleClick={handleClickBys}
                iconVariant="icon-sixteen-px"
              />
            </div>
            <div className="age-container">
              <div className="text-wrapper">
                <div
                  className={
                    estimatedVal.length > 6 ? "upper-text-small" : "upper-text"
                  }
                >
                  {props?.retirementYear}
                </div>
                <div className="lower-text">Age {props?.personAge}</div>
              </div>
              <div className="time-travel-icon">
                <Icons iconname="time-travel" variant="icon-fourty-eight-px" />
              </div>
              <div className="text-wrapper">
                <div
                  className={
                    estimatedVal.length > 6 ? "upper-text-small" : "upper-text"
                  }
                >
                  {isNaN(props?.estimatedVal) ? (
                    <div className="loading-spinner-loader"></div>
                  ) : (
                    <>
                      {estimatedVal.length < 4 ? (
                        <>{generateSpaces(2)}</>
                      ) : estimatedVal.length > 5 && estimatedVal.length < 7 ? (
                        <>{generateSpaces(3)}</>
                      ) : estimatedVal.length > 6 && estimatedVal.length < 8 ? (
                        <>{generateSpaces(3)}</>
                      ) : null}
                      £{showEstimatedVal ? estimatedVal : 0}
                      {estimatedVal.length < 2 ? (
                        <>{generateSpaces(12)}</>
                      ) : (
                        <>
                          {estimatedVal.length < 8 ? (
                            <>
                              {estimatedVal.length < 7 ? (
                                <>{generateSpaces(3)}</>
                              ) : (
                                <>{generateSpaces(3)}</>
                              )}
                            </>
                          ) : null}
                        </>
                      )}
                    </>
                  )}
                </div>
                <div className="lower-text">Estimated value</div>
              </div>
            </div>
            <Row>
              <Col>
                <div className="tell-me-button">
                  <Buttons
                    name="Launch"
                    className="secondary"
                    iconname={isHovered ? "arrow-right-white" : "arrow-right"}
                    variantname="icon-sixteen-px"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    onBlur={handleOnBlur}
                    handleClick={handleEdit}
                  ></Buttons>
                </div>
                <div className="small-text">
                  Time travel is based on{" "}
                  <Link
                    to=""
                    className="anchorTag-color"
                    onClick={handleAssumption}
                  >
                    these assumptions
                  </Link>
                </div>
              </Col>
            </Row>
          </Card.Text>
        </Card.Body>
      </Card>
      <ModalOverlay
        show={modalShow}
        onHide={() => setModalShow(false)}
        modaltitle="Time travel"
        popup="timetravel"
        retirementYear={props?.initialRetirementYear}
        personAge={props?.initialpersonAge}
        newPersonAge={props?.personAge}
        estimatedVal={props?.estimatedVal}
        newRetirementYear={props?.retirementYear}
        initialEstimatedVal={props?.initialEstimatedVal}
        investorObject={investorObject}
        timeTravel={timeTravel}
        handleClick={props?.handleSave}
        totalFund={totalFund}
      />

      <ModalOverlay
        popup="calculatorAssumptions"
        show={timeTravelAssumptionModal}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setTimeTravelAssumptionModal(false);
        }}
        modalTitle="Assumptions we’re making"
        assumptionsFetch={assumptionsFetch}
        assumptionsData={assumptionsData}
        assumptionsError={assumptionsError}
        btnGotItHandler={() => setTimeTravelAssumptionModal(false)}
      />
    </>
  );
};

export default TimeTravel;
